import React from 'react'
import { VStack, StackProps, Stack } from '@chakra-ui/react'

import { Indent, IndentProps } from '../../layout/Indent'

export type { InputProps } from '@chakra-ui/react'
export { Input } from '@chakra-ui/react'

export const FieldSet = (props: StackProps) => (
  <Stack
    as="fieldset"
    spacing="xl"
    alignItems="stretch"
    direction="column"
    {...props}
  />
)

export const FieldRow = ({
  isResponsive = true,
  ...props
}: StackProps & { isResponsive?: boolean }) => (
  <Stack
    spacing="md"
    direction={isResponsive ? ['column', null, 'row'] : 'row'}
    alignItems={['stretch', null, 'flex-start']}
    {...props}
  />
)

export const FieldSetIndent = ({ children, ...props }: IndentProps) => (
  <Indent {...props}>
    <VStack spacing="xl" alignItems="stretch">
      {children}
    </VStack>
  </Indent>
)
